import type { ReactNode } from "react";

type SectionShellProps = {
  title: string;
  icon?: ReactNode;
  right?: ReactNode;
  className?: string;
  children: ReactNode;
};

export default function SectionShell({
  title,
  icon,
  right,
  className = "",
  children,
}: SectionShellProps) {
  return (
    <section
      className={`rounded-xl border border-slate-700/50 bg-black/30 ${className}`}
    >
      <header className="flex items-center justify-between px-4 py-3 border-b border-slate-800/60">
        <h2 className="flex items-center gap-2 text-sm font-semibold text-white">
          {icon}
          <span>{title}</span>
        </h2>
        {right ? <div className="shrink-0">{right}</div> : null}
      </header>
      <div className="p-4">{children}</div>
    </section>
  );
}

